module.exports = __webpack_public_path__ + "img/CARBON-NEUTRAL-PRODUCT.bf44f3f0.png";